import React, { FC, ReactNode, Suspense, useEffect } from 'react'

const LOGGING_ENABLED = false

type Props = {
  name: string // This is useful for debugging
  fallback: ReactNode
}

export const FeedbotSuspense: FC<Props> = ({ fallback, name, children }) => {
  return (
    <Suspense
      fallback={
        <>
          {fallback}
          {LOGGING_ENABLED && <NameLogger name={name} />}
        </>
      }
    >
      {children}
    </Suspense>
  )
}

export type FeedbotSuspenseProps = Props

const NameLogger: FC<{ name: string }> = ({ name }) => {
  useEffect(() => console.log('suspense fallback: ' + name), [])
  return null
}
